import { render } from "./PermissionErr.vue?vue&type=template&id=8b3b739e"
import script from "./PermissionErr.vue?vue&type=script&lang=js"
export * from "./PermissionErr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__